module.exports = __webpack_public_path__ + "b41da65d334e1586fb4858964f89c453.svg";